<script>
import store from '@state/store'
export default {
  props: {
    height: {
      type: String,
      default: '100',
    },
    width: {
      type: String,
      default: '250',
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    logo() {
      return store.getters['parameters/logo']
    },
  },
}
</script>

<template>
  <v-img
    :src="url || logo"
    :max-height="height"
    position="left center"
    :max-width="width"
    class="image"
    contain
  />
</template>

<style>
@media (max-width: 960px) {
  .image {
    max-width: 50% !important;
  }
}
</style>
